export default __webpack_public_path__ + "static/media/top_header_ad_img.6ec9b9fd.png";